import React from 'react';
import { NavLink } from 'react-router-dom';

import { swarmLayers, useSwarm } from '@lbs/swarm-client';

import { getSwarmSubscriptionRequestSecondPopularSports } from '@app/dev/helpers/terminalRequests/popularSports';
import { asyncWrapper } from '@common/hocs/asyncWrapper';
import { useTranslation } from '@common/hooks/translation';

import './style.scss';

const LiveGameBanner = () => {
  const t = useTranslation();

  const data = swarmLayers(useSwarm(getSwarmSubscriptionRequestSecondPopularSports('live')));
  return (
    <div className="live-game-banner">
      <NavLink to="betting/live" className="sportcounts">
        <div className="liveBannerHeader">
          <i className="global-icon icon-circle icon-a" />
          {t('Live Now')}
        </div>
          {data.map((item) => (
            <div key={item.alias}>
              <i className={`sport-icon sport-icon-${item.alias}`} />
              {`${t(item.name)}-${t(item.game)}`}
            </div>
          )).slice(0, 8)}
      </NavLink>
    </div>
  );
};

export default asyncWrapper(LiveGameBanner);
